import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ProfileService } from '../../../services/profile.service';

@Component({
  selector: 'app-profile-change-password',
  templateUrl: './profile-change-password.component.html',
  styleUrls: ['./profile-change-password.component.scss']
})
export class ProfileChangePasswordComponent implements OnInit {

    constructor(private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) {

    }
    currentPassword: any = '';
    newPassword: any = '';
    confirmPassword: any = '';
    btnSaveText: any = 'Save';
    btnSaveDisabled: boolean = false;

    pagecode: string = "profile-change-password";
    module: string = "profile";

    accessdenied: boolean = false;

    ngOnInit(): void {
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);



                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });
    }
    save() {
        if (this.currentPassword === "") {
            this.common.ShowMessage('error', "Please type your Current Password.", "");
        }
        else if (this.newPassword === "") {
            this.common.ShowMessage('error', "Please type your New Password.", "");
        }
        else if (this.newPassword === this.confirmPassword) {
            var passReg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            if (passReg.test(this.newPassword)) {
                this.btnSaveText = "Saving..";
                this.btnSaveDisabled = true;
                this.currentPassword = this.currentPassword.replace("#", "(*%23*)").replace("?", "(*%3F*)");
                this.newPassword = this.newPassword.replace("#", "(*%23*)").replace("?", "(*%3F*)");
                this.profileService.changeMyPassword(this.authentication._authentication.id, this.currentPassword, this.newPassword).subscribe(
                    (res: any) => {
                        if (res.success) {
                            this.btnSaveText = "Save";
                            this.btnSaveDisabled = false;
                            this.common.ShowMessage('info', "You successfully changed your password", "");
                        }
                        else {
                            this.btnSaveText = "Save";
                            this.btnSaveDisabled = false;
                            this.common.ShowMessage('error', res.error_message, "");
                        }

                    },
                    (err: any) => {
                        this.btnSaveText = "Save";
                        this.btnSaveDisabled = false;
                        this.common.ShowMessage('error', err.error.text, "");
                    }
                );
            }
            else {
                this.common.ShowMessage('error', 'Password must be at least 8 characters long, at least one uppercase letter, one lowercase letter, one number and one special character', '');
            }

        }
        else {
            this.common.ShowMessage('error', "New Password and Confirm Password doesn't match.", "");
        }
    }
}